export default __webpack_public_path__ + "static/galeria-launch_1_1_en-b24dd77c719663d2df0d03e9a120c1f8.png";